import { render } from "./FlowNodeSplit.vue?vue&type=template&id=e0a120be&scoped=true&ts=true"
import script from "./FlowNodeSplit.vue?vue&type=script&lang=ts"
export * from "./FlowNodeSplit.vue?vue&type=script&lang=ts"

import "./FlowNodeSplit.vue?vue&type=style&index=0&id=e0a120be&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0a120be"]])

export default __exports__